import { createContext, useContext } from "react";

/**
 * What the request panel can ask of the page around it (WP-2.8): show the requester's message a value
 * was recorded from, or start a message in the composer. Absent on pages without a conversation
 * (the buyer's review, the confirmation): the panel then simply does not offer those actions.
 */
export interface PanelActions {
  /** `messageId`: the turn (assistant reply) that recorded a value; the page shows the requester's message before it. */
  showMessage: (messageId: string) => void;
  draftMessage: (text: string) => void;
}

const PanelActionsContext = createContext<PanelActions | null>(null);

export const PanelActionsProvider = PanelActionsContext.Provider;

export function usePanelActions(): PanelActions | null {
  return useContext(PanelActionsContext);
}
